import Controller from '@ember/controller';

export default class RegisterController extends Controller {
  // keep in sync with /constants.js and login controller
  routeParams = [];
  signupPrefillParams = ['email', 'fname', 'lname', 'handle'];
  publicIdEmailParams = ['gpId', 'epId', 'ppId', 'upId', 'inId'];

  queryParams = this.signupPrefillParams.concat(this.publicIdEmailParams).concat(this.routeParams);
  email = null;
  fname = null;
  lname = null;
  handle = null;
  gpId = null;
  epId = null;
  ppId = null;
  upId = null;
  inId = null;
}
